import { observer } from "mobx-react";
import React, { FC } from "react";
import { useTranslation } from "react-i18next";
import { Colors } from "../../assets";
import XIcon from "../../assets/svgs/x.svg";
import { RegularTextInputProps } from "../../interfaces_and_types";
import "./styles.css";

const RegularTextInput: FC<RegularTextInputProps> = ({
  value,
  icon,
  onChange,
  title,
  error,
  onErrorText,
  inputWidth,
  showTextClearIcon,
  marginsStyle,
  onSubmitEditing,
  inputHeight,
  placeholder,
  onClear,
  borderColor,
  disable,
  inputType,
}) => {
  const { i18n } = useTranslation();
  return (
    <div
      className="regular-text-input-container"
      style={Object.assign(
        {
          paddingTop: "3%",
          paddingLeft: "3%",
          opacity: disable ? 0.4 : undefined,
          borderColor: borderColor !== undefined ? borderColor : undefined,
          borderWidth: borderColor !== undefined ? 1 : undefined,
        },
        marginsStyle
      )}
    >
      {icon !== undefined && icon}
      <label
        className="regular-text-input-title-input-wrapper regular-text-input-title"
        style={{ marginLeft: icon !== undefined ? "3%" : "1%" }}
      >
        {title !== undefined && title}
        <input
          value={value}
          type={inputType}
          className="regular-text-input-input"
          style={{
            fontFamily:
              i18n.language === "ar"
                ? "'Cairo', sans-serif"
                : "'Rubik', sans-serif",

            width: inputWidth,
            height: inputHeight,
          }}
          onChange={onChange}
          placeholder={
            placeholder === undefined ? title?.toLowerCase() : placeholder
          }
          onSubmit={onSubmitEditing}
          disabled={disable}
          onError={() =>
            error !== undefined &&
            onErrorText !== undefined &&
            error && (
              <p
                className="regular-text-input-error"
                // style={
                //   {
                //     //fontFamily: i18n.language === "ar" ? "Cairo" : "Rubik",
                //   }
                // }
              >
                {onErrorText}
              </p>
            )
          }
        />
        {error !== undefined &&
            onErrorText !== undefined &&
            error && (
              onErrorText
            )}
      </label>
      {showTextClearIcon && (
        <img
          className="x-icon"
          src={XIcon}
          alt=""
          height={24}
          width={24}
          style={
            i18n.language === "en"
              ? {
                  borderLeft: 1,
                  borderLeftColor: Colors.GREEN,
                  borderLeftStyle: "solid",
                  paddingLeft: "2%",
                }
              : {
                  borderRight: 1,
                  borderRightColor: Colors.GREEN,
                  borderRightStyle: "solid",
                  paddingRight: "2%",
                }
          }
          onClick={
            onClear === undefined
              ? () => {
                  if (onChange !== undefined) {
                    onChange("");
                  }
                }
              : onClear
          }
        />
      )}
    </div>
  );
};

RegularTextInput.defaultProps = {
  error: false,
  showTextClearIcon: true,
  disable: false,
  inputWidth: 300,
};

export default observer(RegularTextInput);
